import React, { createContext, useContext, useMemo, useState, useCallback } from "react";

const translations = {
  de: {
    nav: {
      journal: "Journal",
      atelier: "Atelier",
      contact: "Kontakt",
    },
    hero: {
      eyebrow: "RESILIÉ — Saison 01",
      title_pre: "Neue Stücke",
      title_em: "erscheinen bald",
      lead:
        "Ein leiser Moment vor dem nächsten Stück. Trete ein in den Kreis und erfahre als Erste:r, wenn die Kollektion erscheint.",
      placeholder: "Deine E-Mail-Adresse",
      cta: "Subscribe",
      cta_loading: "Wird gesendet…",
      legal:
        "Mit dem Abonnieren stimmst du zu, gelegentlich E-Mails von RESILIÉ zu erhalten. Abmeldung jederzeit.",
    },
    philosophy: {
      kicker: "Philosophie",
      quote:
        "RESILIÉ wurde auf einer einfachen Überzeugung gegründet: Was wir tragen, soll uns erheben, nicht erschöpfen. Jedes Stück entsteht in langen Gesprächen mit Webern, Färbern und Schneidern — kleinen Ateliers in Portugal und Norditalien, die sich noch Zeit nehmen.",
    },
    pillars: {
      kicker: "Drei Werte",
      mindful_title: "Mindful",
      mindful_text:
        "Wir gestalten wenige Stücke, gut gemacht. Keine Drops, keine Dringlichkeit. Ein Kleidungsstück tritt der Kollektion nur bei, wenn es hingehört.",
      intentional_title: "Intentional",
      intentional_text:
        "Jede Faser ist gewählt, jede Naht begründet. Schwere Baumwolle aus Portugal. Wolle aus Biella. Leinen aus der Toskana.",
      elevated_title: "Elevated",
      elevated_text:
        "Schönheit liegt in der Proportion, nicht im Logo. Unsere Silhouetten sind leise, präzise und gemacht, um gelebt zu werden.",
    },
    closing: {
      title: "Eine Kollektion, die Zeit braucht.",
      sub: "Estd. 2024 — Mindful. Intentional. Elevated.",
    },
    footer: {
      tagline: "Mindful. Intentional. Elevated.",
      sections: {
        contact: "Kontakt",
        follow: "Folgen",
        legal: "Rechtliches",
      },
      links: {
        instagram: "Instagram",
        pinterest: "Pinterest",
        email: "info@resilie.de",
        imprint: "Impressum",
        privacy: "Datenschutz",
      },
      copyright: "Alle Rechte vorbehalten.",
    },
    toast: {
      success_title: "Willkommen im Kreis.",
      success_desc:
        "Wir haben dir eine kurze Notiz mit einem 10% Willkommens-Code an deine Inbox geschickt.",
      already_title: "Bereits dabei.",
      already_desc: "Diese E-Mail-Adresse ist schon Teil von RESILIÉ.",
      invalid: "Bitte gib eine gültige E-Mail-Adresse ein.",
      error: "Etwas ist schief gelaufen. Bitte versuche es später noch einmal.",
    },
    impressum: {
      title: "Impressum",
      tmg_heading: "Angaben gemäß § 5 TMG",
      represented_heading: "Vertreten durch die Geschäftsführung",
      contact_heading: "Kontakt",
      phone_pending: "wird in Kürze ergänzt",
      vat_heading: "Umsatzsteuer-Identifikationsnummer",
      vat_pending: "USt-IdNr. gemäß § 27 a Umsatzsteuergesetz: wird in Kürze ergänzt",
      responsible_heading: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
      eu_heading: "Streitschlichtung",
      eu_text_pre:
        "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:",
      eu_text_post: "Unsere E-Mail-Adresse findest du oben im Impressum.",
      consumer_arbitration:
        "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucher­schlichtungs­stelle teilzunehmen.",
      liability_heading: "Haftung für Inhalte und Links",
      liability_content:
        "Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.",
      liability_links:
        "Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.",
      copyright_heading: "Urheberrecht",
      copyright_text:
        "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
    },
    datenschutz: {
      title: "Datenschutzerklärung",
      updated_label: "Stand",
      updated_date: "Januar 2026",
      intro:
        "Der Schutz deiner persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten deine Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, BDSG, TTDSG).",
      sections: {
        controller: {
          kicker: "01",
          heading: "Verantwortliche Stelle",
        },
        general: {
          kicker: "02",
          heading: "Allgemeine Hinweise",
          body_1:
            "Die Verarbeitung personenbezogener Daten, beispielsweise deines Namens oder deiner E-Mail-Adresse, erfolgt stets im Einklang mit der Datenschutz-Grundverordnung und in Übereinstimmung mit den geltenden landes­spezifischen Datenschutz­bestimmungen.",
          body_2:
            "Mittels dieser Datenschutz­erklärung möchten wir dich über Art, Umfang und Zweck der von uns erhobenen, genutzten und verarbeiteten personenbezogenen Daten informieren. Ferner werden Betroffene über die ihnen zustehenden Rechte aufgeklärt.",
        },
        hosting: {
          kicker: "03",
          heading: "Hosting",
          body:
            "Wir hosten unsere Website bei einem externen Dienstleister innerhalb der Europäischen Union. Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich u. a. um IP-Adressen, Kontakt­anfragen, Meta- und Kommunikationsdaten sowie Website-Zugriffe handeln.",
          legal_basis:
            "Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse besteht in einer zuverlässigen Darstellung unserer Website. Mit dem Hoster wurde ein Auftrags­verarbeitungs­vertrag (AVV) geschlossen.",
        },
        logs: {
          kicker: "04",
          heading: "Server-Log-Dateien",
          body:
            "Der Provider erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien, die dein Browser automatisch übermittelt. Dies sind:",
          list: [
            "Browsertyp und Browserversion",
            "verwendetes Betriebssystem",
            "Referrer URL",
            "Hostname des zugreifenden Rechners",
            "Uhrzeit der Serveranfrage",
            "IP-Adresse (anonymisiert)",
          ],
          retention:
            "Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Logfiles werden nach 14 Tagen automatisch gelöscht.",
        },
        cookies: {
          kicker: "05",
          heading: "Cookies",
          body_1:
            "Unsere Website verwendet derzeit ausschließlich technisch notwendige Cookies, die für den Betrieb der Seite erforderlich sind (z. B. zur Speicherung deiner Sprachauswahl). Diese Cookies werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO bzw. § 25 Abs. 2 TTDSG verwendet.",
          body_2:
            "Du kannst deinen Browser so einstellen, dass du über das Setzen von Cookies informiert wirst und Cookies nur im Einzelfall erlaubst, die Annahme von Cookies für bestimmte Fälle oder generell ausschließt sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivierst.",
        },
        newsletter: {
          kicker: "06",
          heading: "Newsletter & Willkommens-Code",
          body_1:
            "Wenn du den Newsletter abonnieren möchtest, benötigen wir von dir eine valide E-Mail-Adresse. Mit der Anmeldung erklärst du dich einverstanden, gelegentlich E-Mails von RESILIÉ zu erhalten — insbesondere die Willkommens-E-Mail mit deinem persönlichen 10% Rabattcode (WELCOME10).",
          body_2:
            "Die Verarbeitung der eingegebenen Daten erfolgt ausschließlich auf Grundlage deiner Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Du kannst die Einwilligung jederzeit widerrufen, etwa über den Abmelde-Link in jeder E-Mail oder per Nachricht an info@resilie.de.",
          body_3:
            "Die Rechtmäßigkeit der bereits erfolgten Datenverarbeitungs­vorgänge bleibt vom Widerruf unberührt. Deine E-Mail-Adresse wird nach Abmeldung von uns gelöscht, sofern keine gesetzlichen Aufbewahrungs­pflichten entgegenstehen.",
          processor:
            "Für den Versand der Newsletter & Bestätigungs­mails nutzen wir den Dienst Resend (Resend Inc., Delaware, USA). Resend ist ein zuverlässiger E-Mail-Dienstleister, der nach DSGVO-konformen Standards arbeitet. Mit Resend wurde ein Auftrags­verarbeitungs­vertrag (AVV) abgeschlossen. Datenschutz­erklärung von Resend:",
        },
        contact: {
          kicker: "07",
          heading: "Kontaktaufnahme",
          body:
            "Wenn du uns per E-Mail kontaktierst, werden deine Angaben zwecks Bearbeitung der Anfrage und für den Fall von Anschluss­fragen bei uns gespeichert. Diese Daten geben wir nicht ohne deine Einwilligung weiter. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertrags­anbahnung) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an effektiver Kommunikation).",
        },
        analytics: {
          kicker: "08",
          heading: "Analyse-Tools & Tracking",
          body:
            "Aktuell setzen wir keine Web-Analyse-Tools (wie Google Analytics, Matomo o. ä.) und kein Tracking ein. Sollte sich dies ändern, werden wir diese Datenschutz­erklärung anpassen und — wo erforderlich — vorab deine Einwilligung einholen.",
        },
        rights: {
          kicker: "09",
          heading: "Deine Rechte",
          intro:
            "Du hast jederzeit das Recht auf:",
          list: [
            "Auskunft über die zu deiner Person gespeicherten Daten (Art. 15 DSGVO)",
            "Berichtigung unrichtiger Daten (Art. 16 DSGVO)",
            "Löschung deiner Daten (Art. 17 DSGVO)",
            "Einschränkung der Verarbeitung (Art. 18 DSGVO)",
            "Datenübertragbarkeit (Art. 20 DSGVO)",
            "Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)",
            "Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)",
          ],
          contact:
            "Zur Ausübung deiner Rechte genügt eine formlose Nachricht an info@resilie.de.",
          complaint:
            "Du hast außerdem das Recht, dich bei der zuständigen Aufsichts­behörde zu beschweren. Zuständig ist die Landes­beauftragte für den Datenschutz Niedersachsen (LfD).",
        },
        storage: {
          kicker: "10",
          heading: "Speicherdauer",
          body:
            "Soweit innerhalb dieser Datenschutz­erklärung keine speziellere Speicherdauer genannt wurde, verbleiben deine personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn du einen berechtigten Löschantrag stellst oder eine Einwilligung widerrufst, werden deine Daten gelöscht, sofern keine gesetzlichen Aufbewahrungs­pflichten entgegen­stehen.",
        },
        changes: {
          kicker: "11",
          heading: "Änderungen dieser Datenschutzerklärung",
          body:
            "Wir behalten uns vor, diese Datenschutz­erklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen umzusetzen. Für deinen erneuten Besuch gilt dann die neue Datenschutz­erklärung.",
        },
      },
    },
  },
  en: {
    nav: {
      journal: "Journal",
      atelier: "Atelier",
      contact: "Contact",
    },
    hero: {
      eyebrow: "RESILIÉ — Season 01",
      title_pre: "New Pieces",
      title_em: "Coming Soon",
      lead:
        "A quiet moment before the next piece. Step into the circle and be the first to know when the collection arrives.",
      placeholder: "Your email address",
      cta: "Subscribe",
      cta_loading: "Sending…",
      legal:
        "By subscribing you agree to receive occasional emails from RESILIÉ. Unsubscribe anytime.",
    },
    philosophy: {
      kicker: "Philosophy",
      quote:
        "RESILIÉ was founded on a simple conviction: what we wear should elevate us, not exhaust us. Every piece is born from long conversations with weavers, dyers and tailors — small ateliers in Portugal and northern Italy that still take their time.",
    },
    pillars: {
      kicker: "Three Values",
      mindful_title: "Mindful",
      mindful_text:
        "We make few pieces, well made. No drops, no urgency. A garment only joins the collection when it belongs.",
      intentional_title: "Intentional",
      intentional_text:
        "Every fibre is chosen, every seam considered. Heavy cotton from Portugal. Wool from Biella. Linen from Tuscany.",
      elevated_title: "Elevated",
      elevated_text:
        "Beauty lives in proportion, not in logos. Our silhouettes are quiet, precise, and made to be lived in.",
    },
    closing: {
      title: "A collection that takes its time.",
      sub: "Estd. 2024 — Mindful. Intentional. Elevated.",
    },
    footer: {
      tagline: "Mindful. Intentional. Elevated.",
      sections: {
        contact: "Contact",
        follow: "Follow",
        legal: "Legal",
      },
      links: {
        instagram: "Instagram",
        pinterest: "Pinterest",
        email: "info@resilie.de",
        imprint: "Imprint",
        privacy: "Privacy",
      },
      copyright: "All rights reserved.",
    },
    toast: {
      success_title: "Welcome to the circle.",
      success_desc:
        "We've sent a quiet note with your 10% welcome code to your inbox.",
      already_title: "Already in.",
      already_desc: "This email is already part of RESILIÉ.",
      invalid: "Please enter a valid email address.",
      error: "Something went quietly wrong. Please try again later.",
    },
    impressum: {
      title: "Imprint",
      tmg_heading: "Information pursuant to § 5 TMG",
      represented_heading: "Represented by the Management",
      contact_heading: "Contact",
      phone_pending: "to be added shortly",
      vat_heading: "VAT identification number",
      vat_pending: "VAT-ID pursuant to § 27 a UStG: to be added shortly",
      responsible_heading:
        "Responsible for content according to § 18 (2) MStV",
      eu_heading: "Online Dispute Resolution",
      eu_text_pre:
        "The European Commission provides a platform for online dispute resolution (ODR):",
      eu_text_post: "Our email address can be found above.",
      consumer_arbitration:
        "We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.",
      liability_heading: "Liability for content & links",
      liability_content:
        "As a service provider we are responsible for our own content on these pages according to § 7 (1) TMG and the general laws. According to §§ 8 to 10 TMG, however, we are not obliged as a service provider to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity.",
      liability_links:
        "Our offer contains links to external websites of third parties, on whose content we have no influence. Therefore, we cannot assume any liability for these external contents. The respective provider or operator of the linked pages is always responsible for the content.",
      copyright_heading: "Copyright",
      copyright_text:
        "The content and works on these pages created by the site operators are subject to German copyright law. Duplication, processing, distribution and any kind of utilisation outside the limits of copyright law require the written consent of the respective author or creator.",
    },
    datenschutz: {
      title: "Privacy Policy",
      updated_label: "Last updated",
      updated_date: "January 2026",
      intro:
        "The protection of your personal data is particularly important to us. We process your data exclusively on the basis of legal regulations (GDPR, BDSG, TTDSG).",
      sections: {
        controller: {
          kicker: "01",
          heading: "Data Controller",
        },
        general: {
          kicker: "02",
          heading: "General Notes",
          body_1:
            "The processing of personal data, such as your name or email address, is always carried out in line with the General Data Protection Regulation and in compliance with applicable country-specific data protection regulations.",
          body_2:
            "By means of this privacy policy, we would like to inform you about the type, scope and purpose of the personal data we collect, use and process. Furthermore, data subjects are informed of the rights to which they are entitled.",
        },
        hosting: {
          kicker: "03",
          heading: "Hosting",
          body:
            "We host our website with an external service provider within the European Union. The personal data collected on this website is stored on the servers of the host. This may include IP addresses, contact requests, meta and communication data, and website access information.",
          legal_basis:
            "The legal basis is Art. 6 (1) lit. f GDPR. Our legitimate interest is the reliable presentation of our website. A data processing agreement (DPA) has been concluded with the host.",
        },
        logs: {
          kicker: "04",
          heading: "Server log files",
          body:
            "The provider automatically collects and stores information in so-called server log files, which your browser transmits automatically. These are:",
          list: [
            "Browser type and browser version",
            "Operating system used",
            "Referrer URL",
            "Hostname of the accessing computer",
            "Time of the server request",
            "IP address (anonymised)",
          ],
          retention:
            "This data is not merged with other data sources. The collection is based on Art. 6 (1) lit. f GDPR. Log files are automatically deleted after 14 days.",
        },
        cookies: {
          kicker: "05",
          heading: "Cookies",
          body_1:
            "Our website currently uses only technically necessary cookies that are required for the operation of the site (e.g. to store your language selection). These cookies are used on the basis of Art. 6 (1) lit. f GDPR or § 25 (2) TTDSG.",
          body_2:
            "You can configure your browser to inform you about the setting of cookies and to allow cookies only in individual cases, exclude the acceptance of cookies for certain cases or generally, and activate the automatic deletion of cookies when the browser is closed.",
        },
        newsletter: {
          kicker: "06",
          heading: "Newsletter & Welcome Code",
          body_1:
            "If you would like to subscribe to the newsletter, we need a valid email address from you. By signing up, you agree to receive occasional emails from RESILIÉ — in particular the welcome email containing your personal 10% discount code (WELCOME10).",
          body_2:
            "The processing of the data entered is carried out exclusively on the basis of your consent (Art. 6 (1) lit. a GDPR). You can revoke your consent at any time, e.g. via the unsubscribe link in every email or by sending a message to info@resilie.de.",
          body_3:
            "The legality of the data processing operations already carried out remains unaffected by the revocation. Your email address will be deleted after unsubscribing, unless statutory retention obligations prevent this.",
          processor:
            "For sending newsletters & confirmation emails we use the service Resend (Resend Inc., Delaware, USA). Resend is a reliable email service provider that operates according to GDPR-compliant standards. A data processing agreement (DPA) has been concluded with Resend. Resend's privacy policy:",
        },
        contact: {
          kicker: "07",
          heading: "Contact requests",
          body:
            "If you contact us by email, your information will be stored for the purpose of processing the request and in case of follow-up questions. We do not pass on this data without your consent. The legal basis is Art. 6 (1) lit. b GDPR (initiation of contract) or Art. 6 (1) lit. f GDPR (legitimate interest in effective communication).",
        },
        analytics: {
          kicker: "08",
          heading: "Analytics & tracking",
          body:
            "We currently do not use any web analytics tools (such as Google Analytics, Matomo, etc.) and no tracking. Should this change, we will adapt this privacy policy and — where necessary — obtain your consent in advance.",
        },
        rights: {
          kicker: "09",
          heading: "Your rights",
          intro:
            "You have the right at any time to:",
          list: [
            "Information about the data stored about you (Art. 15 GDPR)",
            "Correction of incorrect data (Art. 16 GDPR)",
            "Erasure of your data (Art. 17 GDPR)",
            "Restriction of processing (Art. 18 GDPR)",
            "Data portability (Art. 20 GDPR)",
            "Objection to processing (Art. 21 GDPR)",
            "Withdrawal of consent given (Art. 7 (3) GDPR)",
          ],
          contact:
            "To exercise your rights, an informal message to info@resilie.de is sufficient.",
          complaint:
            "You also have the right to lodge a complaint with the competent supervisory authority. The competent authority is the State Commissioner for Data Protection in Lower Saxony (LfD Niedersachsen).",
        },
        storage: {
          kicker: "10",
          heading: "Storage period",
          body:
            "Unless a more specific storage period has been mentioned within this privacy policy, your personal data will remain with us until the purpose for the data processing ceases to apply. If you submit a justified deletion request or revoke consent, your data will be deleted, provided no statutory retention obligations prevent this.",
        },
        changes: {
          kicker: "11",
          heading: "Changes to this privacy policy",
          body:
            "We reserve the right to adapt this privacy policy so that it always complies with current legal requirements or in order to implement changes to our services. The new privacy policy will then apply to your next visit.",
        },
      },
    },
  },
};

const LanguageContext = createContext({
  lang: "de",
  setLang: () => {},
  t: translations.de,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window !== "undefined") {
      const stored = window.localStorage.getItem("resilie_lang");
      if (stored === "de" || stored === "en") return stored;
    }
    return "de";
  });

  const setLang = useCallback((next) => {
    setLangState(next);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("resilie_lang", next);
    }
  }, []);

  const value = useMemo(
    () => ({ lang, setLang, t: translations[lang] }),
    [lang, setLang]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
